import { RadioGroup, Button, Icon } from '@pwc/pwc-deals-ui';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

export const StartIngestionModalBody = ({ handleStartClick }) => {
  const [selectedType, setSelectedType] = useState('');

  const radioGroupField = {
    name: 'ingestion-type-select',
    value: selectedType,
    onChange: (event) => setSelectedType(event.target.value),
  };

  const radioGroupOptions = [
    { label: 'PowerPoint', value: 'PowerPoint' },
    { label: 'Power BI', value: 'PowerBI' },
  ];

  return (
    <>
      <Modal.Body>
        <div data-testid="start-ingestion-body">
          <h5>Select to import from PowerPoint or Power BI</h5>
          <div className="import-hint">
            <Icon
              name="information"
              className="fill icon-yellow"
              width={16}
              data-testid="hint-icon"
            />
            <p>
              Make sure your PowerPoint files are saved in SharePoint, and your
              Power BI reports are published to Workbench
            </p>
          </div>
          <RadioGroup field={radioGroupField} options={radioGroupOptions} />
          <div className="import-callout">
            To ingest data from an Excel file, use the Junction Excel add-in.
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-actions">
          <Button
            type="button"
            disabled={!selectedType}
            onClick={() => handleStartClick(selectedType)}
            data-testid="start-ingestion-button"
          >
            Next
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};
